import { TransactionStatus, NotificationStatus } from './status.model'

export interface TransactionDetails {
    transactionId: string
    processorTransactionId: string
    amount: number
    status: TransactionStatus
    effectiveDate: string
    settlementDate: string | null

    subMerchantName: string
    subMerchantId: string
    accountHolderName: string
    transactionDate: string
    transactionType: string
    submittedBy: string
    product: string
    originType: string
    bankAccountType: string
    maskedAccountNumber: string
    routingNumber: string

    authorizationType: string | null
    authorizationDateTime: string | null
    authorizationReference: string | null
    authorizationReferenceDate: string | null

    returnDate: string | null
    returnReasonCode: string | null
    returnReasonDescription: string | null
    retryAttempt: string | null

    nocCode: string | null
    nocDescription: string | null
    nocDate: string | null

    refundInfo: RefundCard[] | null

    relatedTransactions: RelatedTransaction[]
    notifications: NotificationEntry[]
    history: HistoryEntry[]
    exportHistory: ExportHistoryEntry[]
}

export interface RefundCard {
    refundTransactionId: string
    refundNotificationType: string | null
    refundDate: string
    refundAmount: number
    refundBy: string | null
}

export interface RelatedTransaction {
    transactionId: string
    transactionDate: string
    amount: number
    status: TransactionStatus
    relationship: string
}

export interface NotificationEntry {
    notificationType: string
    sentDateTime: string
    recipient: string
    status: NotificationStatus
    templateType: string
    referenceId: string | null
}

export interface HistoryEntry {
    achStatus: TransactionStatus
    dateTime: string
    updatedBy: string
}

export interface ExportHistoryEntry {
    userName: string
    timeStamp: string
}

export enum AccountType {
    Checking = 0,
    Savings = 1,
}

export const AccountTypeLabels: Record<AccountType, string> = {
    [AccountType.Checking]: 'Checking',
    [AccountType.Savings]: 'Savings',
}
